const genericGetError = "generic.error.get.data";
const genericSaveError = "generic.save.error";

const ApiUtils = {
  // error: the error
  // statuses: for what error/s the received message should not be returned and the generic one is returned
  // returns the error message translation code
  computeGetError(error, defaultErrorMessage = genericGetError, statuses = []) {
    let errorMessage = defaultErrorMessage;
    if (error && error.response && error.response.status === 401 && !error.config?.refresh) {
      errorMessage = null;
    } else {
      let showResponseError = statuses?.length > 0 && error.response?.data?.status && statuses.includes(error.response?.data?.status.toString()) ? false : true

      if (error && error.response && error.response.data && error.response.data.message && showResponseError) {
        errorMessage = error.response.data.message
      }
    }

    return errorMessage;
  },

  // error: the error  
  // defaultErrorMessage: default error mesaage
  // returns the error message translation code
  computeSaveError(error, defaultErrorMessage = genericSaveError) {
    let errorMessage = defaultErrorMessage;
    if (error && error.response && error.response.status === 401 && !error.config?.refresh) {
      errorMessage = null;
    } else {
      if (error && error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      }
    }

    return errorMessage;
  },

  // error: the error  
  // defaultErrorMessage: default error mesaage
  // returns the error message translation code
  computeSaveErrorArray(error, defaultErrorMessage = genericSaveError) {
    let errorMessage = defaultErrorMessage;    
    if (error && error.response && error.response.status === 401 && !error.config?.refresh) {
      errorMessage = null;
    } else {
      if (error && error.response && error.response.data) {
        if (error.response.data.errorCodes) {
          if (error.response.data.errorIDs) {
            return ({ hasValidationError: true, errorCodes: error.response.data.errorCodes, errorIDs : error.response.data.errorIDs })
          } else {
            return ({ hasValidationError: true, errorCodes: error.response.data.errorCodes })
          }
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
    }

    return ({ hasValidationError: false, errorMessage: errorMessage });
  },

  computeCheckErrorArray(error, defaultErrorMessage = genericGetError) {    
    let errorMessage = defaultErrorMessage;
    if (error && error.response && error.response.status === 401 && !error.config?.refresh) {
      errorMessage = null;
    } else {
      if (error && error.response && error.response.data) {
        if (error.response.data.errorCodes) {
          return ({ hasValidationError: true, errorCodes: error.response.data.errorCodes })
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
    }

    return ({ hasValidationError: false, errorMessage: errorMessage });
  },

  // error: the error
  // returns the error message translation code
  computeFileDownloadGetError(error, defaultErrorMessage = genericGetError) {
    let errorMessage = defaultErrorMessage;
    if (error) {
      let errorJson = JSON.parse(error)
      if (errorJson && errorJson.message) {
        errorMessage = errorJson.message
      }
    }

    return errorMessage;
  },

  computeFileUploadErrorArray(error, defaultErrorMessage = genericSaveError) {
    let errorMessage = defaultErrorMessage;
    if (error && error.response && error.response.status === 401 && !error.config?.refresh) {
      errorMessage = null;
    } else {
      if (error) {
        if (error.errorCodes) {
          return ({ hasValidationError: true, errorCodes: error.errorCodes })
        } else if (error.message) {
          errorMessage = error.message;
        }
      }
    }

    return ({ hasValidationError: false, errorMessage: errorMessage });
  },

};

export default ApiUtils;
